import { render } from "./References.vue?vue&type=template&id=7f41a7cd"
import script from "./References.vue?vue&type=script&setup=true&lang=js"
export * from "./References.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/learning_module/components/reference/References.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f41a7cd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f41a7cd', __exports__)) {
    api.reload('7f41a7cd', __exports__)
  }
  
  module.hot.accept("./References.vue?vue&type=template&id=7f41a7cd", () => {
    api.rerender('7f41a7cd', render)
  })

}


export default __exports__